import React, { useState, useEffect, useContext } from 'react';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';

import UserContext from 'src/context/UserContext';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { sendInBlueApiKey } from 'src/api/environment';
import { sendInBlueUrl } from 'src/api/environment';
import { url } from 'src/api/environment';

import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  section: {
    padding: '5rem',
    [theme.breakpoints.down('xs')]: {
      padding: '1rem',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '2rem',
    },
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const AccountView = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  let { userData, setUserData } = useContext(UserContext);

  const [loading, setLoading] = useState(false);

  const logout = () => {
    setUserData({
      token: undefined,
      user: undefined,
    });
    localStorage.setItem('auth-token', '');
    enqueueSnackbar('A bientôt =)', { variant: 'success' });
    navigate('/home');
  }

  const registerToNewsletter = () => {
    setLoading(true);
    axios.post(sendInBlueUrl, { email: userData.user.email }, {
      headers: {
        'Content-Type': 'application/json',
        'api-key': sendInBlueApiKey,
      },      
    })      
      .then((response) => {
        console.log(userData.token)
        axios.put(`${url}/users/update`, { email: userData.user.email, isRegisteredToNewsletter: true }, {
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': userData.token,
          },      
        })   
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar('La requête n\'a pas pu être réalisé, réessayer plus tard', { variant: 'error' });
      })
      .finally(() => {
        setUserData({
          user: {...userData.user, isRegisteredToNewsletter: true}
        });
        setLoading(false);
        enqueueSnackbar('Votre inscription à la newsletter à bien été reçu', { variant: 'success' });
      })
  }
  useEffect(() => {
    if (!userData) {
      navigate('/');
    }
  }, [userData]);

  return (
    <>
      <Container
        className={classes.section}
        disableGutters
      >
        <Paper
          className={classes.section}
          component="header"
        >
          <Typography
            component="h2"
            variant="h1"
          >
            Mon compte
          </Typography>
          <Typography
            component="p"
            variant="body2"
          >
            <Divider />
            {userData.user.email ?
              <>
                <Typography style={{marginTop: '2rem'}}>
                Vous êtes connecté avec le compte : {userData.user.email}<br />
                </Typography>
                <Typography
                  style={{marginTop: '1.5rem'}}
                  variant="h3"
                >
                  {userData.user.displayName}
                </Typography>
              </>
              :
              <Navigate to="/home" />
            }
          </Typography>
          <Typography
            component="p"
            style={{fontSize: '1rem'}}
            variant="body2"
          >
            Cet espace est toujours en construction et vous permettra de consulter vos données personnelles, vos réussites vos trophés mais aussi l'impact environnemental que vous avez généré depuis le début de votre activité.
          </Typography>
          {!userData.user.isRegisteredToNewsletter ?
            <>
              <Typography
                component="p"
                style={{fontSize: '1rem'}}
                variant="body2"
              >
            Vous pouvez toujours vous inscrire à la newsletter ci dessous en cliquant sur l'enveloppe verte.
              </Typography>
              <Paper
                className={classes.root}
                component="form"
                style={{marginTop: '4rem', maxWidth: '100%'}}
              >
                <InputBase
                  className={classes.input}
                  inputProps={{ 'aria-label': 'inscription à la newsletter' }}
                  value={userData.user.email}
                />
                <Divider
                  className={classes.divider}
                  orientation="vertical"
                />
                <IconButton
                  aria-label="directions"
                  className={classes.iconButton}
                  color="primary"
                  onClick={registerToNewsletter}
                >
                  {loading ?
                    <CircularProgress
                      size={30}
                      style={{}}
                    />
                    :
                    <SendIcon />
                  }
                </IconButton>
              </Paper>
            </>
            :
            <Typography
              component="p"
              style={{fontSize: '1rem', color: '#70c359'}}
              variant="body2"
            >
            Vous êtes inscrit à la Newsletter 😜
            </Typography>
          }
          <Button
            color="secondary"
            onClick={logout}
            size="small"
            style={{marginTop: '2rem'}}
            type="submit"
            variant="contained"
          >
            Déconnexion
          </Button>
        </Paper>
      </Container>
    </>
  );
}

export default AccountView;
